import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logonamebg from '../image/logonamenobg.png';
import logo from '../image/logonobg.png';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

  :root {
    --green: #169c66;
    --green-dark: #117a50;
    --green-light: #e8f7f1;
    --green-mid: #d0f0e3;
    --text: #1a1a1a;
    --text-2: #444;
    --text-3: #777;
    --border: #ddd;
    --white: #fff;
    --off-white: #f9fafb;
  }

  .lp * { margin: 0; padding: 0; box-sizing: border-box; }

  .lp {
    font-family: 'Plus Jakarta Sans', sans-serif;
    color: var(--text);
    background: var(--white);
    overflow-x: hidden;
  }

  /* NAV */
  .lp-nav {
    position: fixed;
    top: 0; left: 0; right: 0;
    z-index: 100;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 6%;
    background: rgba(255,255,255,0.92);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(221,221,221,0.5);
    transition: box-shadow 0.3s;
  }
  .lp-nav.scrolled { box-shadow: 0 2px 16px rgba(22,156,102,0.08); }

  .lp-nav-logo {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.3rem;
    font-weight: 800;
    color: var(--green);
    letter-spacing: -0.5px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  
  .lp-nav-logo-img {
    height: 75px;
    width: auto;
    object-fit: contain;
  }

  .lp-nav-links {
    display: flex;
    align-items: center;
    gap: 2rem;
    list-style: none;
  }
  .lp-nav-links a {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--text-2);
    text-decoration: none;
    transition: color 0.2s;
  }
  .lp-nav-links a:hover { color: var(--green); }

  .lp-nav-actions { display: flex; gap: 0.6rem; align-items: center; }

  .lp-btn-outline {
    padding: 0.45rem 1.1rem;
    border: 1.5px solid var(--green);
    border-radius: 8px;
    color: var(--green);
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    font-size: 0.85rem;
    background: transparent;
    cursor: pointer;
    transition: background 0.2s;
  }
  .lp-btn-outline:hover { background: var(--green-light); }

  .lp-btn-solid {
    padding: 0.45rem 1.1rem;
    border: none;
    border-radius: 8px;
    background: var(--green);
    color: white;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
    transition: background 0.2s, transform 0.15s;
  }
  .lp-btn-solid:hover { background: var(--green-dark); transform: translateY(-1px); }

  .lp-hamburger {
    display: none;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px;
  }
  .lp-hamburger span {
    display: block; width: 22px; height: 2px;
    background: var(--text); border-radius: 2px; transition: 0.3s;
  }

  .lp-mob-menu {
    display: none;
    position: fixed;
    top: 64px; left: 0; right: 0;
    background: white;
    border-bottom: 1px solid var(--border);
    padding: 1rem 6%;
    z-index: 99;
    flex-direction: column;
    box-shadow: 0 8px 24px rgba(0,0,0,0.06);
  }
  .lp-mob-menu.open { display: flex; }
  .lp-mob-menu a {
    display: block;
    padding: 0.75rem 0;
    border-bottom: 1px solid #f0f0f0;
    color: var(--text-2);
    text-decoration: none;
    font-weight: 500;
    font-size: 0.95rem;
  }
  .lp-mob-menu a:last-child { border-bottom: none; color: var(--green); font-weight: 700; }

  /* HERO */
  .lp-hero {
    min-height: 100vh;
    display: flex;
    align-items: center;
    padding: 96px 6% 60px;
    background: var(--white);
    position: relative;
    overflow: hidden;
  }
  .lp-hero::before {
    content: '';
    position: absolute;
    top: -140px; right: -100px;
    width: 500px; height: 500px;
    background: radial-gradient(circle, rgba(22,156,102,0.08) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
  }
  .lp-hero::after {
    content: '';
    position: absolute;
    bottom: -80px; left: -60px;
    width: 300px; height: 300px;
    background: radial-gradient(circle, rgba(22,156,102,0.05) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
  }

  .lp-hero-inner {
    max-width: 1100px;
    margin: 0 auto;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    align-items: center;
    position: relative;
    z-index: 1;
  }

  .lp-hero-tag {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.28rem 0.875rem;
    background: var(--green-light);
    border: 1px solid rgba(22,156,102,0.22);
    border-radius: 100px;
    font-size: 0.73rem;
    font-weight: 600;
    color: var(--green);
    margin-bottom: 1.2rem;
    animation: lpFadeUp 0.5s ease both;
  }
  .lp-htag-dot { width: 6px; height: 6px; background: var(--green); border-radius: 50%; }

  .lp-hero-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: clamp(2.1rem, 4.5vw, 3.3rem);
    font-weight: 800;
    line-height: 1.12;
    letter-spacing: -1.5px;
    color: var(--text);
    margin-bottom: 1rem;
    animation: lpFadeUp 0.5s 0.08s ease both;
  }
  .lp-hero-title em { font-style: normal; color: var(--green); }

  .lp-hero-desc {
    font-size: 0.975rem;
    color: var(--text-3);
    line-height: 1.78;
    max-width: 420px;
    margin-bottom: 2rem;
    animation: lpFadeUp 0.5s 0.15s ease both;
  }

  .lp-hero-btns {
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
    animation: lpFadeUp 0.5s 0.22s ease both;
  }
  .lp-btn-hero {
    padding: 0.78rem 1.75rem;
    background: var(--green);
    color: white;
    border: none;
    border-radius: 10px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 700;
    font-size: 0.95rem;
    cursor: pointer;
    transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
    box-shadow: 0 4px 18px rgba(22,156,102,0.28);
  }
  .lp-btn-hero:hover {
    background: var(--green-dark);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(22,156,102,0.36);
  }
  .lp-btn-ghost {
    padding: 0.78rem 1.75rem;
    background: white;
    color: var(--text-2);
    border: 1.5px solid var(--border);
    border-radius: 10px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: border-color 0.2s, color 0.2s;
  }
  .lp-btn-ghost:hover { border-color: var(--green); color: var(--green); }

  /* CARD VISUAL */
  .lp-hero-visual {
    display: flex;
    align-items: center;
    justify-content: center;
    animation: lpFadeUp 0.6s 0.18s ease both;
  }
  .lp-card-scene {
    position: relative;
    width: 310px;
    height: 400px;
  }
  .lp-card-main {
    position: absolute;
    top: 30px; left: 16px;
    width: 252px;
    background: linear-gradient(145deg, #0d7a50 0%, #169c66 55%, #1db87a 100%);
    border-radius: 18px;
    padding: 1.6rem;
    box-shadow: 0 20px 52px rgba(22,156,102,0.34);
    z-index: 3;
    animation: cardBob1 5s ease-in-out infinite;
  }
  @keyframes cardBob1 {
    0%,100%{transform:translateY(0) rotate(-1.5deg);}
    50%{transform:translateY(-10px) rotate(-1.5deg);}
  }
  .lp-cv-avatar {
    width: 44px; height: 44px;
    background: rgba(255,255,255,0.2);
    border: 2px solid rgba(255,255,255,0.4);
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 0.95rem; font-weight: 800; color: white;
    margin-bottom: 0.8rem;
  }
  .lp-cv-name { font-size: 0.95rem; font-weight: 700; color: white; margin-bottom: 0.18rem; }
  .lp-cv-role { font-size: 0.68rem; color: rgba(255,255,255,0.7); margin-bottom: 1.1rem; }
  .lp-cv-sep { height: 1px; background: rgba(255,255,255,0.15); margin-bottom: 0.875rem; }
  .lp-cv-row { display: flex; align-items: center; gap: 0.45rem; margin-bottom: 0.45rem; }
  .lp-cv-icon {
    width: 17px; height: 17px;
    background: rgba(255,255,255,0.15);
    border-radius: 5px;
    display: flex; align-items: center; justify-content: center;
    font-size: 0.58rem; flex-shrink: 0;
  }
  .lp-cv-txt { font-size: 0.68rem; color: rgba(255,255,255,0.82); }

  .lp-card-back {
    position: absolute;
    top: 0; right: 0;
    width: 210px;
    background: white;
    border: 1px solid var(--border);
    border-radius: 18px;
    padding: 1.2rem;
    box-shadow: 0 8px 28px rgba(0,0,0,0.09);
    z-index: 2;
    animation: cardBob2 6.5s ease-in-out infinite;
  }
  @keyframes cardBob2 {
    0%,100%{transform:translateY(0) rotate(3deg);}
    50%{transform:translateY(-8px) rotate(3deg);}
  }
  .lp-cb-brand { font-size: 0.78rem; font-weight: 800; color: var(--green); margin-bottom: 0.55rem; }
  .lp-cb-lbl { font-size: 0.67rem; color: var(--text-3); font-weight: 500; margin-bottom: 0.35rem; }
  .lp-pill {
    display: inline-block;
    padding: 0.18rem 0.5rem;
    background: var(--green-light);
    border-radius: 100px;
    font-size: 0.63rem;
    color: var(--green);
    font-weight: 600;
    margin: 0.1rem;
  }
  .lp-cb-stat {
    margin-top: 0.8rem;
    padding-top: 0.8rem;
    border-top: 1px solid #f0f0f0;
    display: flex; justify-content: space-between; align-items: flex-end;
  }
  .lp-cb-num { font-size: 1rem; font-weight: 800; color: var(--text); }
  .lp-cb-lbl2 { font-size: 0.62rem; color: var(--text-3); margin-top: 2px; }
  .lp-mini-bars { display: flex; gap: 3px; align-items: flex-end; height: 26px; }
  .lp-bar { width: 5px; border-radius: 3px; background: var(--green); opacity: 0.5; }

  .lp-float-tag {
    position: absolute;
    bottom: 28px; right: 8px;
    background: white;
    border-radius: 10px;
    padding: 0.55rem 0.8rem;
    box-shadow: 0 4px 18px rgba(0,0,0,0.09);
    display: flex; align-items: center; gap: 0.4rem;
    z-index: 4;
    animation: tagBob 7s ease-in-out infinite;
  }
  @keyframes tagBob { 0%,100%{transform:translateY(0);} 50%{transform:translateY(-6px);} }
  .lp-ft-dot { width: 7px; height: 7px; background: #22c55e; border-radius: 50%; }
  .lp-ft-txt { font-size: 0.7rem; font-weight: 600; color: var(--text); }

  /* ABOUT */
  .lp-about {
    padding: 80px 6%;
    background: var(--off-white);
  }
  .lp-about-inner {
    max-width: 1100px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5rem;
    align-items: center;
  }

  .lp-sec-label {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: var(--green);
    margin-bottom: 0.55rem;
  }
  .lp-sec-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: clamp(1.55rem, 3vw, 2.1rem);
    font-weight: 800;
    letter-spacing: -0.75px;
    color: var(--text);
    margin-bottom: 0.875rem;
    line-height: 1.2;
  }
  .lp-about-text p {
    font-size: 0.875rem;
    color: var(--text-2);
    line-height: 1.82;
    margin-bottom: 0.875rem;
  }

  .lp-pillars {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;
    margin-top: 1.5rem;
  }
  .lp-pillar {
    padding: 1rem;
    background: white;
    border: 1px solid var(--border);
    border-radius: 12px;
    transition: border-color 0.2s;
  }
  .lp-pillar:hover { border-color: rgba(22,156,102,0.35); }
  .lp-pillar-icon { font-size: 1rem; margin-bottom: 0.35rem; }
  .lp-pillar h5 { font-size: 0.8rem; font-weight: 700; color: var(--text); margin-bottom: 0.18rem; }
  .lp-pillar p { font-size: 0.72rem; color: var(--text-3); line-height: 1.55; margin: 0; }

  /* about orbit visual */
  .lp-av {
    display: flex; align-items: center; justify-content: center;
    min-height: 280px; position: relative;
  }
  .lp-av-ring {
    position: absolute; border-radius: 50%;
    border: 1.5px dashed rgba(22,156,102,0.2);
  }
  .lp-av-r1 { width: 250px; height: 250px; animation: spinR 24s linear infinite; }
  .lp-av-r2 { width: 170px; height: 170px; animation: spinR 18s linear infinite reverse; }
  @keyframes spinR { from{transform:rotate(0);} to{transform:rotate(360deg);} }
  .lp-av-center {
    width: 100px; height: 100px;
    background: var(--green);
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    box-shadow: 0 10px 32px rgba(22,156,102,0.33);
    position: relative; z-index: 1;
  }
  .lp-av-center-txt {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1rem; font-weight: 800; color: white;
    text-align: center; line-height: 1.15;
  }
  .lp-av-node {
    position: absolute;
    width: 34px; height: 34px;
    background: white; border: 1.5px solid var(--border);
    border-radius: 9px;
    display: flex; align-items: center; justify-content: center;
    font-size: 0.85rem;
    box-shadow: 0 2px 10px rgba(0,0,0,0.07);
    z-index: 2;
  }

  /* PRIVACY */
  .lp-privacy {
    padding: 80px 6%;
    background: white;
  }
  .lp-privacy-inner { max-width: 740px; margin: 0 auto; }
  .lp-privacy-top { margin-bottom: 1.5rem; }
  .lp-privacy-date { font-size: 0.76rem; color: var(--text-3); margin-top: 0.4rem; }

  .lp-acc {
    border: 1px solid var(--border);
    border-radius: 12px;
    margin-bottom: 0.5rem;
    overflow: hidden;
    transition: border-color 0.2s;
  }
  .lp-acc.open { border-color: rgba(22,156,102,0.32); }
  .lp-acc-btn {
    width: 100%;
    display: flex; justify-content: space-between; align-items: center;
    padding: 0.9rem 1.1rem;
    background: none; border: none; cursor: pointer;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 0.845rem; font-weight: 600; color: var(--text);
    text-align: left; transition: background 0.15s;
  }
  .lp-acc-btn:hover { background: var(--off-white); }
  .lp-acc.open .lp-acc-btn { color: var(--green); background: var(--green-light); }
  .lp-acc-arrow { font-size: 0.65rem; color: var(--text-3); transition: transform 0.25s; flex-shrink: 0; }
  .lp-acc.open .lp-acc-arrow { transform: rotate(180deg); color: var(--green); }
  .lp-acc-body {
    max-height: 0; overflow: hidden;
    transition: max-height 0.35s ease, padding 0.25s;
    padding: 0 1.1rem;
  }
  .lp-acc.open .lp-acc-body { max-height: 500px; padding: 0 1.1rem 1rem; }
  .lp-acc-body p, .lp-acc-body li { font-size: 0.83rem; color: var(--text-2); line-height: 1.8; }
  .lp-acc-body ul { padding-left: 1.25rem; margin-top: 0.35rem; }
  .lp-acc-body li { margin-bottom: 0.22rem; }
  .lp-acc-body h4 { font-size: 0.78rem; font-weight: 700; color: var(--text); margin: 0.7rem 0 0.28rem; }
  .lp-acc-body strong { color: var(--text); }

  .lp-contact-box {
    margin-top: 1.25rem;
    padding: 1rem 1.1rem;
    background: var(--green-light);
    border: 1px solid rgba(22,156,102,0.22);
    border-radius: 12px;
    display: flex; align-items: center; gap: 0.55rem;
  }
  .lp-contact-box span { font-size: 0.845rem; color: var(--text-2); }
  .lp-contact-box a { color: var(--green); font-weight: 600; text-decoration: none; font-size: 0.845rem; }
  .lp-contact-box a:hover { text-decoration: underline; }

  /* FOOTER */
  .lp-footer { background: #0e1812; padding: 48px 6% 26px; }
  .lp-footer-grid {
    max-width: 1100px; margin: 0 auto;
    display: grid; grid-template-columns: 2fr 1fr 1fr;
    gap: 3rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid rgba(255,255,255,0.07);
  }
  .lp-f-logo {
    font-size: 1.2rem;
    font-weight: 800;
    color: var(--green);
    margin-bottom: 0.55rem;
    display: flex;
    align-items: center;
  }
  
  .lp-footer-logo-img {
    height: 32px;
    width: auto;
    object-fit: contain;
  }
  
  .lp-footer-brand p { font-size: 0.78rem; color: rgba(255,255,255,0.45); line-height: 1.7; max-width: 210px; }
  .lp-f-maillink {
    display: inline-flex; align-items: center; gap: 0.35rem;
    margin-top: 0.8rem;
    color: rgba(22,156,102,0.85); text-decoration: none;
    font-size: 0.78rem; font-weight: 500; transition: color 0.2s;
  }
  .lp-f-maillink:hover { color: var(--green); }
  .lp-footer-col h5 {
    font-size: 0.72rem; font-weight: 700;
    color: rgba(255,255,255,0.8);
    margin-bottom: 0.8rem; letter-spacing: 0.5px; text-transform: uppercase;
  }
  .lp-footer-col ul { list-style: none; display: flex; flex-direction: column; gap: 0.45rem; }
  .lp-footer-col ul a { color: rgba(255,255,255,0.45); text-decoration: none; font-size: 0.8rem; transition: color 0.2s; }
  .lp-footer-col ul a:hover { color: rgba(255,255,255,0.8); }
  .lp-footer-bottom {
    max-width: 1100px; margin: 1.4rem auto 0;
    display: flex; justify-content: space-between; align-items: center;
    flex-wrap: wrap; gap: 0.5rem;
    font-size: 0.72rem; color: rgba(255,255,255,0.3);
  }

  /* REVEAL */
  @keyframes lpFadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .lp-reveal {
    opacity: 0; transform: translateY(24px);
    transition: opacity 0.6s ease, transform 0.6s ease;
  }
  .lp-reveal.lp-vis { opacity: 1; transform: translateY(0); }

  /* RESPONSIVE */
  @media (max-width: 900px) {
    .lp-nav-links, .lp-nav-actions { display: none; }
    .lp-hamburger { display: flex; }
    .lp-hero-inner { grid-template-columns: 1fr; }
    .lp-hero-visual { display: none; }
    .lp-hero { padding: 90px 6% 50px; min-height: auto; }
    .lp-about-inner { grid-template-columns: 1fr; gap: 2.5rem; }
    .lp-av { min-height: 200px; }
    .lp-footer-grid { grid-template-columns: 1fr 1fr; gap: 2rem; }
  }
  @media (max-width: 560px) {
    .lp-hero-btns { flex-direction: column; }
    .lp-pillars { grid-template-columns: 1fr; }
    .lp-footer-grid { grid-template-columns: 1fr; gap: 1.5rem; }
    .lp-footer-bottom { flex-direction: column; text-align: center; }
    .lp-av { display: none; }
    
    /* JUSTIFICATION FOR MOBILE */
    .lp-hero-desc,
    .lp-about-text p,
    .lp-acc-body p,
    .lp-acc-body li,
    .lp-contact-box span,
    .lp-footer-brand p,
    .lp-footer-bottom span {
      text-align: justify;
    }
    
    .lp-hero-title {
      text-align: left;
    }
    
    .lp-sec-title {
      text-align: left;
    }
    
    .lp-hero-btns {
      justify-content: center;
    }
    
    .lp-contact-box {
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
    }
  }
`;

const privacySections = [
  {
    title: "1. Introduction",
    body: (
      <p>Welcome to NexCard ("we", "our", "us"). We operate a web-based platform that allows users to create and manage digital profiles by uploading and sharing business-related information. We are committed to protecting your privacy and handling your personal information responsibly.</p>
    ),
  },
  {
    title: "2. Information We Collect",
    body: (
      <>
        <h4>Personal Information</h4>
        <ul><li>Name</li><li>Email address</li><li>Phone number</li></ul>
        <h4>Business Information</h4>
        <ul><li>Business name &amp; description</li><li>Social media links &amp; website URLs</li></ul>
        <h4>Uploaded Content</h4>
        <ul><li>Profile images, business photos, visiting cards</li></ul>
        <h4>Technical Information</h4>
        <ul><li>IP address, browser type, device information, usage data</li></ul>
      </>
    ),
  },
  {
    title: "3. How We Use Your Information",
    body: <p>We use collected information to provide and maintain our services, display your digital profile, improve the platform, communicate support updates, and ensure security and prevent misuse.</p>,
  },
  {
    title: "4. Data Sharing and Disclosure",
    body: <p>We do <strong>not sell or rent</strong> your personal information. We may share data only with service providers who help operate our platform, when required by law, or to prevent fraud.</p>,
  },
  {
    title: "5. Data Storage and Security",
    body: <p>We implement appropriate technical and organizational measures to protect your data. No internet transmission is 100% secure, but we strive to use commercially acceptable means to protect your information.</p>,
  },
  {
    title: "6. User Responsibility",
    body: (
      <>
        <p>Users are responsible for content they upload. You must not upload:</p>
        <ul><li>False or misleading information</li><li>Content that violates laws</li><li>Unauthorized or copyrighted material</li></ul>
      </>
    ),
  },
  {
    title: "7. Cookies and Tracking",
    body: <p>We may use cookies and similar technologies to improve user experience and analyze traffic patterns. You can control cookies through your browser settings.</p>,
  },
  {
    title: "8. Third-Party Links",
    body: <p>Our platform may contain links to external websites or social media. We are not responsible for the privacy practices of those third-party sites.</p>,
  },
  {
    title: "9. Data Retention",
    body: <p>We retain your information as long as your account is active or as needed to provide our services. You may request deletion of your data by contacting us.</p>,
  },
  {
    title: "10. Your Rights",
    body: <p>You have the right to access, correct, or delete your data, and to withdraw consent where applicable. Contact us at the email below to exercise these rights.</p>,
  },
  {
    title: "11. Children's Privacy",
    body: <p>Our services are not intended for individuals under 18. We do not knowingly collect personal data from children.</p>,
  },
  {
    title: "12. Policy Updates",
    body: <p>We may update this policy from time to time. Changes will be posted on this page with an updated effective date.</p>,
  },
];

const AccordionItem = ({ title, body }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`lp-acc${open ? " open" : ""}`}>
      <button className="lp-acc-btn" onClick={() => setOpen(!open)}>
        {title}
        <span className="lp-acc-arrow">▼</span>
      </button>
      <div className="lp-acc-body">{body}</div>
    </div>
  );
};

const LandingPage = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const year = new Date().getFullYear();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("lp-vis");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -30px 0px" }
    );
    document.querySelectorAll(".lp-reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="lp">
      <style>{styles}</style>

      {/* NAV */}
      <nav className={`lp-nav${scrolled ? " scrolled" : ""}`}>
        <span className="lp-nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src={logonamebg} alt="NexCard" className="lp-nav-logo-img" />
        </span>
        <ul className="lp-nav-links">
          <li><a href="#about">About</a></li>
          <li><a href="#privacy">Privacy</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
        <div className="lp-nav-actions">
          <button className="lp-btn-outline" onClick={() => navigate("/login")}>Log In</button>
          <button className="lp-btn-solid" onClick={() => navigate("/signup")}>Sign Up</button>
        </div>
        <button className="lp-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </nav>

      <div className={`lp-mob-menu${menuOpen ? " open" : ""}`}>
        <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
        <a href="#privacy" onClick={() => setMenuOpen(false)}>Privacy</a>
        <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
        <a href="/login" onClick={() => setMenuOpen(false)}>Log In →</a>
      </div>

      {/* HERO */}
      <section className="lp-hero">
        <div className="lp-hero-inner">
          <div>
            <div className="lp-hero-tag">
              <span className="lp-htag-dot" />
              Digital Business Cards
            </div>
            <h1 className="lp-hero-title">
              Your card,<br />
              <em>always with them</em>
            </h1>
            <p className="lp-hero-desc">
              Add your Valuable business card, share it anywhere with a link or QR code, and make every introduction count.
            </p>
            <div className="lp-hero-btns">
              <button className="lp-btn-hero" onClick={() => navigate("/signup")}>
                Add Your Card
              </button>
              <button className="lp-btn-ghost" onClick={() => navigate("/login")}>
                Sign In
              </button>
            </div>
          </div>

          {/* Card mockup */}
          <div className="lp-hero-visual">
            <div className="lp-card-scene">

              {/* Main card - blank template style */}
              <div className="lp-card-main">
                <div className="lp-cv-avatar" style={{ background: 'rgba(255,255,255,0.18)', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.5px' }}>YOU</div>
                <div className="lp-cv-name" style={{ background: 'rgba(255,255,255,0.15)', borderRadius: '6px', height: '12px', width: '110px', marginBottom: '6px' }} />
                <div className="lp-cv-role" style={{ background: 'rgba(255,255,255,0.1)', borderRadius: '4px', height: '8px', width: '80px', marginBottom: '1.1rem' }} />
                <div className="lp-cv-sep" />
                <div className="lp-cv-row">
                  <div className="lp-cv-icon">✉</div>
                  <div className="lp-cv-txt" style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '4px', height: '8px', width: '120px' }} />
                </div>
                <div className="lp-cv-row">
                  <div className="lp-cv-icon">📱</div>
                  <div className="lp-cv-txt" style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '4px', height: '8px', width: '95px' }} />
                </div>
                <div className="lp-cv-row">
                  <div className="lp-cv-icon">🌐</div>
                  <div className="lp-cv-txt" style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '4px', height: '8px', width: '105px' }} />
                </div>
              </div>

              {/* Back card - QR / share panel */}
              <div className="lp-card-back">
                <div className="lp-cb-brand">Share</div>
                <div className="lp-cb-lbl">Your card link</div>

                {/* Fake URL pill */}
                <div style={{
                  background: '#f4f4f4',
                  borderRadius: '6px',
                  padding: '0.3rem 0.5rem',
                  fontSize: '0.63rem',
                  color: '#888',
                  marginBottom: '0.6rem',
                  letterSpacing: '0.2px'
                }}>
                  nexcard.co.in/<span style={{ color: '#169c66', fontWeight: 700 }}>yourname</span>
                </div>

                {/* Mini QR placeholder */}
                <div style={{
                  width: '56px', height: '56px',
                  background: '#f0f0f0',
                  borderRadius: '6px',
                  margin: '0.4rem 0',
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  gap: '2px',
                  padding: '6px'
                }}>
                  {[1,0,1,0, 0,1,0,1, 1,1,0,0, 0,0,1,1].map((v, i) => (
                    <div key={i} style={{
                      background: v ? '#1a1a1a' : 'transparent',
                      borderRadius: '1px'
                    }} />
                  ))}
                </div>

                <div className="lp-cb-stat">
                  <div>
                    <div className="lp-cb-num">QR</div>
                    <div className="lp-cb-lbl2">Ready</div>
                  </div>
                  <div style={{ fontSize: '1.1rem' }}>↗</div>
                </div>
              </div>

              {/* Floating tag */}
              <div className="lp-float-tag">
                <div className="lp-ft-dot" />
                <div className="lp-ft-txt">Ready to share</div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section id="about" className="lp-about">
        <div className="lp-about-inner">
          <div className="lp-about-text lp-reveal">
            <div className="lp-sec-label">About NexCard</div>
            <h2 className="lp-sec-title">Built for modern professionals</h2>
            <p>
              NexCard is a digital business card platform designed for India's growing professional community. We make it effortless to share who you are — and keep your contacts always up to date.
            </p>
            <p>
              Whether you're a freelancer, founder, or corporate professional, NexCard gives you a living profile you can share with a link or QR code — no app needed on the other end.
            </p>
            <div className="lp-pillars">
              <div className="lp-pillar">
                <div className="lp-pillar-icon">⚡</div>
                <h5>Instant sharing</h5>
                <p>Share via link & QR . Works on every device.</p>
              </div>
              <div className="lp-pillar">
                <div className="lp-pillar-icon">🔄</div>
                <h5>Always current</h5>
                <p>Update once — everyone sees the latest version.</p>
              </div>
              <div className="lp-pillar">
                <div className="lp-pillar-icon">🔒</div>
                <h5>Secure</h5>
                <p>Your data protected with industry-standard security.</p>
              </div>
              <div className="lp-pillar">
                <div className="lp-pillar-icon">🇮🇳</div>
                <h5>Made for India</h5>
                <p>Designed with Indian professionals in mind.</p>
              </div>
            </div>
          </div>

          <div className="lp-av lp-reveal">
            <div className="lp-av-ring lp-av-r1">
              <div className="lp-av-node" style={{ top: "-17px", left: "50%", transform: "translateX(-50%)" }}>✉</div>
              <div className="lp-av-node" style={{ bottom: "-17px", left: "50%", transform: "translateX(-50%)" }}>🌐</div>
              <div className="lp-av-node" style={{ left: "-17px", top: "50%", transform: "translateY(-50%)" }}>📱</div>
              <div className="lp-av-node" style={{ right: "-17px", top: "50%", transform: "translateY(-50%)" }}>💼</div>
            </div>
            <div className="lp-av-ring lp-av-r2" />
            <div className="lp-av-center">
              <div className="lp-av-center-txt">Nex<br />Card</div>
            </div>
          </div>
        </div>
      </section>

      {/* PRIVACY */}
      <section id="privacy" className="lp-privacy">
        <div className="lp-privacy-inner">
          <div className="lp-privacy-top lp-reveal">
            <div className="lp-sec-label">Legal</div>
            <h2 className="lp-sec-title">Privacy Policy</h2>
            <div className="lp-privacy-date">Effective Date: April 1, 2025</div>
          </div>
          <div className="lp-reveal">
            {privacySections.map((s) => (
              <AccordionItem key={s.title} title={s.title} body={s.body} />
            ))}
          </div>
          <div className="lp-contact-box lp-reveal">
            <span>📧</span>
            <span>
              Questions about this policy?{" "}
              <a href="mailto:enquiry@nexcard.co.in">enquiry@nexcard.co.in</a>
            </span>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer id="contact" className="lp-footer">
        <div className="lp-footer-grid">
          <div className="lp-footer-brand">
            <div className="lp-f-logo">
              <img src={logo} alt="NexCard" className="lp-footer-logo-img" /> NexCard
            </div>
            <p>Digital business cards for India's modern professionals.</p>
            <a href="mailto:enquiry@nexcard.co.in" className="lp-f-maillink">
              📧 enquiry@nexcard.co.in
            </a>
          </div>
          <div className="lp-footer-col">
            <h5>Platform</h5>
            <ul>
              <li><a href="/login">Log In</a></li>
              <li><a href="/signup">Sign Up</a></li>
            </ul>
          </div>
          <div className="lp-footer-col">
            <h5>Legal</h5>
            <ul>
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><a href="mailto:enquiry@nexcard.co.in">Contact Us</a></li>
            </ul>
          </div>
        </div>
        <div className="lp-footer-bottom">
          <span>© {year} NexCard. All rights reserved.</span>
          <span>support@nexcard.co.in</span>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;